// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1gwfz","name":"Header_name__3pW6N","birthday":"Header_birthday__3cU2t","skeleton":"Header_skeleton__3KHzR"};